// extracted by mini-css-extract-plugin
export default {"root":"Feed-module-root","title":"Feed-module-title"};